module.exports = __webpack_public_path__ + "img/icon-wa.f055e032.png";